// extracted by mini-css-extract-plugin
export default {"Regular":"CbkCeHvk"};